<div class="compliance-container">
	<div class="compliance-container-inner">
		<img
			class="d-none d-md-block orange-pattern-overlay"
			src="../../assets/img/orange-pattern.png"
			alt=""
		/>
		<img
			class="d-md-none orange-pattern-overlay"
			src="../../assets/img/orange-pattern-mobile.png"
			alt=""
		/>
		<div class="container text-center">
			<h2 class="reduce-risk-header">Affordable Options for Everyone</h2>
			<div class="row">
				<div class="col-lg-4 affordable-card mb-5">
					<div class="affordable-card-container">
						<div class="border1">
							<div class="card1">
								<span>COMMUNITY EDITION</span>
								<h1>Free</h1>
								<ul>
									<li>Unlimited Users</li>
									<li>Unlimited Records</li>
									<li>{{ modCount }} Compliance Modules</li>
									<li>{{ catCount}} Catalogues</li>
								</ul>

								<button
									class="
										complaince-button
										py-2
										px-4
										mt-4 mt-lg-5
									" (click)="download()"
								>
									Download Now
								</button>
							</div>
						</div>
					</div>
				</div>

				<div class="col-lg-4 affordable-card mb-5">
					<div class="affordable-card-container">
						<div class="border2">
							<div class="card2">
								<span>Enterprise Edition </span>
								<h1>Contact Us</h1>
								<ul>
									<li>Multi-Tenant</li>
									<li>Custom Fields</li>
									<li>Time Travel</li>
									<li>Integrations</li>
								</ul>
								<a [routerLink]="['/contact']">
									<button
										class="
											complaince-button
											py-2
											px-4
											mt-4 mt-lg-5
										"
									>
										Contact Us
									</button>
								</a>
							</div>
						</div>
					</div>
				</div>

				<div class="col-lg-4 affordable-card">
					<div class="affordable-card-container">
						<div class="border3">
							<div class="card3">
								<span>Managed Edition </span>
								<h1>Contact Us</h1>
								<ul>
									<li>Private Hosting</li>
									<li>Custom SLAs</li>
									<li>on premises Integrations</li>
									<li>Concierge Services</li>
								</ul>
								<a [routerLink]="['/contact']">
									<button
										class="
											complaince-button
											py-2
											px-4
											mt-4 mt-lg-5
										"
									>
										Contact Us
									</button>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<p class="mt-5">
				All modules are available in every version of RegScale;
				<br class="d-none d-md-block" />
				features vary by version, as shown above.
			</p>
		</div>
	</div>
</div>
<div class="volume-discounts-container">
	<img
		class="d-none d-md-block orange-pattern-overlay"
		src="../../assets/img/orange-pattern.png"
		alt=""
	/>
	<div class="container text-center">
		<h2 class="volume-header">
			Volume discounts <br />
			are available
		</h2>

		<div
			class="
				volume-bottom
				d-flex
				flex-column flex-lg-row
				align-content-center
				justify-content-between
			"
		>
			<a href="https://go.regscale.com/RegScale-Create-Account">
				<button class="complaince-button py-2 px-4 mt-5 mt-lg-5">
					Sign Up for Free
				</button></a
			>
			<a [routerLink]="['/contact']">
				<button class="complaince-button py-2 px-4 mt-4 mt-lg-5">
					Contact Us
				</button></a
			>
		</div>
	</div>
</div>
